

<app-auth-layout>
  @if(showValidateCode){
    <div>
      <h1>Crea tu cuenta</h1>
    </div>
    <div>
      <form [formGroup]="formRegister" (ngSubmit)="onSubmit()">
        <div class="form-inner">
          <div class="input-container">
            <input type="text" class="form-control" formControlName="name" required
                   placeholder="Nombre completo"
                   [ngClass]="{'error-required': submitted && formRegister.get('name')?.hasError('required')}"/>
          </div>

          <div class="input-container">
            <input type="email" class="form-control" formControlName="email" required
                   placeholder="Email"
                   [ngClass]="{
                     'error-required': submitted && formRegister.get('email')?.hasError('required'),
                     'error-format': submitted && !formRegister.get('email')?.hasError('required') && formRegister.get('email')?.invalid}"/>
          </div>

          <div class="input-container">
            <input type="password" class="form-control" formControlName="password" required
                   placeholder="Contraseña"
                   [ngClass]="{
                     'error-required': submitted && formRegister.get('password')?.hasError('required')}"/>
          </div>

          <div class="input-container">
            <input type="password" class="form-control" formControlName="confirmPassword" required
                   placeholder="confirmacion de contraseña"
                   [ngClass]="{
                     'error-required': submitted && formRegister.get('confirmPassword')?.hasError('required')}"/>
          </div>
        </div>

        @if(showEmptyFieldsError){
          <div class="error-felds-imcomplet">
            Ingresa todos tus datos para continuar.
          </div>
        }

        @if(!showEmptyFieldsError && (submitted && formRegister.invalid)){
        <div  class="error-felds">
          @if(!formRegister.get('name')?.invalid && formRegister.get('email')?.invalid){
            <ng-container class="container-error">  <img src="/assets/icons/error.svg" alt="Icono" class="icon"/> El correo no es válido.</ng-container>
          }
          @if(!formRegister.get('name')?.invalid && !formRegister.get('email')?.invalid && formRegister.get('password')?.invalid){
            <ng-container class="container-error">  <img src="/assets/icons/error.svg" alt="Icono" class="icon"/> La contraseña debe incluir 8 dígitos, iniciar con mayúscula y tener un caracter especial.</ng-container>
          }
          @if(!formRegister.get('name')?.invalid && !formRegister.get('email')?.invalid && !formRegister.get('password')?.invalid && formRegister.errors?.['passwordsNoCoinciden']){
            <ng-container class="container-error">  <img src="/assets/icons/error.svg" alt="Icono" class="icon"/> Las contraseñas no coinciden.</ng-container>
          }
        </div>
        }

        <div class="container-buttons">
          <button type="button" (click)="onCancel()">Cancelar</button>
          <button type="submit" >Siguiente</button>
        </div>
      </form>
    </div>
  }
  @if(!showValidateCode){
    <app-validation-code></app-validation-code>
  }

  @if(!showMessageSucces){
    <app-message-succes [menssage]="messageModal"></app-message-succes>
  }
</app-auth-layout>


